import { SVGProps } from 'react';

export function CreditSearchTickIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={20}
      fill="none"
      {...props}
    >
      <path
        fill="#07A35D"
        d="M10.5 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-10 8c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10Zm14.664-3.247a1 1 0 0 1 .083 1.411l-5.333 6a1 1 0 0 1-1.495 0l-2.666-3a1 1 0 0 1 1.494-1.328l1.92 2.159 4.586-5.16a1 1 0 0 1 1.411-.082Z"
      />
    </svg>
  );
}

export function CreditSearchStrokeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      {...props}
    >
      <path
        fill="#EE6B00"
        d="M3.68 14.906A8 8 0 0 1 14.905 3.68L3.68 14.905Zm1.414 1.414L16.32 5.094A8 8 0 0 1 5.094 16.32ZM0 10c0 5.523 4.477 10 10 10s10-4.477 10-10S15.523 0 10 0 0 4.477 0 10Z"
      />
    </svg>
  );
}

export function CreditSearchCrossIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      {...props}
    >
      <path
        fill="#DF4040"
        d="M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Zm5.793-4.207a1 1 0 0 1 1.414 0L10 8.586l2.793-2.793a1 1 0 1 1 1.414 1.414L11.414 10l2.793 2.793a1 1 0 0 1-1.414 1.414L10 11.414l-2.793 2.793a1 1 0 0 1-1.414-1.414L8.586 10 5.793 7.207a1 1 0 0 1 0-1.414Z"
      />
    </svg>
  );
}

export function CreditSearchNAIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={22}
      fill="none"
      {...props}
    >
      <rect width={24} height={22} fill="#EE6B00" rx={4} />
      <path
        fill="#fff"
        d="M9.176 16H6.867L3.141 9.52h-.053c.074 1.144.111 1.96.111 2.449V16H1.576V7.434h2.291l3.72 6.416h.042a51.94 51.94 0 0 1-.088-2.362V7.434h1.635V16Zm5.982-8.566L11.965 16h-1.623l3.193-8.566h1.623ZM21.54 16l-.621-2.04h-3.123L17.174 16h-1.957l3.023-8.602h2.22L23.497 16H21.54Zm-1.055-3.563a1760.81 1760.81 0 0 1-.972-3.134 9.822 9.822 0 0 1-.153-.574c-.129.5-.498 1.736-1.107 3.709h2.232Z"
      />
    </svg>
  );
}
